// extracted by mini-css-extract-plugin
export default {"container":"text_area_container__fEM42","label":"text_area_label__fC0Rz","textArea":"text_area_textArea__I+urk"};